<template>
    <div class="table-import">
        <ul class="table-import__tips fs-12 lh-20 p-8 color-333">
            <li>1.目前上传文件仅支持Excel表格文件，请下载系统提供的Excel模板，商品数据量限制在200行以内，并且严格遵循规定填写。详细规则见附件。<a class="href fx-v-center" href="https://d.senguo.cc/ls/tpl/%E5%95%86%E5%93%81%E6%95%B0%E6%8D%AE%E8%A1%A8%E6%A0%BC%E7%A4%BA%E4%BE%8B.xlsx">（点击下载:<img src="../images/table_download_icon.svg" alt="download-icon">商品数据表格 (示例).xlxs）</a>，带红色<span class="color-red">*</span>的为必填项。</li>
            <li>2.若导入重名商品，将不会做商品数据合并，而是自动创建为新商品。</li>
            <li>3.若不填写商品分组，则默认将商品置于所有商品组别中；若填写分组不存在，将按先后顺序自动创建新分组，超出分组上限的商品将视为无分组处理；若未填写一级分组却填写了二级分组，视同未填写分组处理。</li>
            <li>4.商品类目可参考，<a class="href fx-v-center" @click="() => $refs.ChooseGoodsType.open()">《商品类目》</a>中的类目名称，请填写对应中文；暂不支持导入自定义商品图片，商品图片将根据类目名称选择系统默认图片。</li>
            <li>5.销售单位可填写系统默认单位和已建立的自定义单位，库存单位默认与销售单位相同；若填写的单位不存在，将视同需修改的错误数据。</li>
            <li>6.阶梯价请按照【数量，价格】格式填写，相关单位将自动带出；若未填写二级阶梯价，但填写了三级阶梯价，将视同无阶梯价处理。</li>
            <li>7.若填写了商品库存，则会把库存扣减设置默认设置为“添加到订单时扣减库存”、“允许库存为负数但弹出警告”，若需修改请添加完成导入后在商品编辑页面逐一设置。</li>
        </ul>
        <choose-goods-type ref="ChooseGoodsType"></choose-goods-type>
        <begin-import class="mt-20" :type="1" />
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import BeginImport from '../components/begin_import.vue'
import ChooseGoodsType from "../../goods_add_and_edit/modules/choose_goods_types.vue"

export default createComponent({
    setup: (props, ctx) => {

        return {

        }
    },

    components: {
        BeginImport,
        ChooseGoodsType
    }
})
</script>

<style lang="scss" scoped>
.table-import {
    &__tips {
        background-color: #f7f7f7;

        li > a {
            display: inline-flex;

            img {
                width: 18px;
            }
        }
    }
}
</style>
